<template>
    <div class="appheaderbg">
        <div :class="{appheader_container: true, appheader_active: getheaderflag}">
            <div class="logo">
                <a href="https://udn70.udn.com/" target="_blank" rel="noopener" aria-label="聯logo" name="聯logo">
                    <img class="logomanage" src="https://p3.udn.com.tw/wish/images/common/logo.svg" @click="clicktitle"/>
                </a>
            </div>
            <div class="contactpart">
                <a :href="fbshareUrl" target="_blank" rel="noopener" aria-label="share-fb" title="share-fb">
                    <img class="s_fb" src="https://p3.udn.com.tw/wish/images/common/fb_icon.svg" @click="clicksharefb"/>
                </a>
                <a :href="lineshareUrl" :target="target" rel="noopener" aria-label="share-line" title="share-line">
                    <img class="s_line" src="https://p3.udn.com.tw/wish/images/common/line_icon.svg" @click="clickshareline"/>
               </a>
               <a :href="twittershareUrl" target="_blank" rel="noopener" aria-label="share-twitter" title="share-twitter">
                    <img class="s_twitter" src="https://p3.udn.com.tw/wish/images/common/twitter_icon.svg" @click="clicksharetwitter"/>
                </a>
                <div class="hamburgercontain" @click="handleHamburgerClick">
                    <hamburger :menuActiveFlag="menuActiveFlag"/>
                </div>
            </div>
        </div>
        <hamburgermenu :menuActiveFlag="menuActiveFlag">
            <div class="hamburgermenu-block">
                <a href="https://udn70.udn.com/" target="_blank" @click="hamburgerlink('menu_bar_main_page')">
                    聯合七十 許願未來
                </a>
            </div>
            <div class="hamburgermenu-block">
                <a href="https://udn70.udn.com/story/" target="_blank" @click="hamburgerlink('menu_bar_past_70')">
                    見證台灣重要時刻
                </a>
            </div>
            <div class="hamburgermenu-block" @click="hamburgerlink('menu_bar_wishers')">
                <a href="https://udn70.udn.com/wish/sustainability_23" target="_blank" @click="hamburgerlink('menu_bar_past_70')" class="active">
                    守護台灣的70位實踐家
                </a>
            </div>
            <div class="hamburgermenu-block">
                <a href="https://event.udn.com/lianfu70/" target="_blank" @click="hamburgerlink('MenuLianfu')">
                    聯合副刊七十周年
                </a>
            </div>
            <div class="hamburgermenu-block">
                <a href="https://udn.com/upf/ubrand/2021_data/sustainability/" target="_blank" @click="hamburgerlink('MenuSustainability')">
                    永續祝福
                </a>
            </div>
            <div class="hamburgermenu-block">
                <a href="https://docs.google.com/forms/d/e/1FAIpQLScA49vvk8CUnFsAxK7OqXZ9XBbP8sQ_-a0l9UuB0_WZGzp4mQ/viewform" target="_blank" @click="hamburgerlink('menu_bar_plus_one')">
                    邀請您一起響應
                </a>
            </div>
            <div class="hamburgermenu-block">
                <a href="https://udn70.udn.com/digital-transformation/" target="_blank" @click="hamburgerlink('menu_bar_report')">
                    聯合報數位轉型報告
                </a>
            </div>
            <div class="hamburgermenu-block">
                <a href="https://www.vision10years.com.tw/" target="_blank" @click="hamburgerlink('menu_bar_vision')">
                    聯合報系願景工程
                </a>
            </div>
            <div class="space" style="width: 100%; height: 100px;">

            </div>
        </hamburgermenu>
        <sidemenu>
            
        </sidemenu>
        <menubutton @click="clicksidemenu()">

        </menubutton>
        <featurebutton>

        </featurebutton>
        <heartanimation>

        </heartanimation>
    </div>
</template>
  
<script>
    import { sendGaMethods } from '@/assets/js/utils/masterBuilder.js';
    import hamburger from '@/components/header/hamburger.vue';
    import hamburgermenu from '@/components/header/hamburgermenu.vue';
    import sidemenu from '@/components/header/sidemenu.vue'
    import menubutton from '@/components/header/menubutton.vue'
    import featurebutton from '@/components/header/featurebutton.vue'
    import heartanimation from '@/components/header/heartanimation.vue'
    import Utils from '@/assets/js/utils/udn-newmedia-utils.js'
    const isMobile = Utils.detectMob();
    const isInApp = Utils.isFacebookApp(148) || Utils.isLineApp();
    export default {
        mixins: [sendGaMethods],
        components: {
            hamburger,
            hamburgermenu,
            sidemenu,
            menubutton, 
            featurebutton,
            heartanimation,
        },
        data(){
            return{
                href:"https://udn70.udn.com/wish/",
                menuActiveFlag: false,
                height: 0,
                last_stage: 0,
            }
        },
        created () {
            window.addEventListener('scroll', this.onScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.onScroll);
        },
        computed: {
            getheaderflag(){
                return this.$store.state.hideNavBar;
            },
            fbshareUrl() {
                let url = encodeURIComponent(this.href+this.$route.path.split('/').reverse()[0]);
                return ('https://www.facebook.com/dialog/share?app_id=1010324812347164&display=popup&href=' + url + '&redirect_uri=' + url);
            },
            lineshareUrl() {
                if (!isMobile) {
                    return `https://social-plugins.line.me/lineit/share?text=${encodeURIComponent(document.querySelector('meta[property="og:title"]').content)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}&url=${encodeURIComponent(this.href+this.$route.path.split('/').reverse()[0])}`
                }
                // mobile
                if (!isInApp) {
                    return `https://line.naver.jp/R/msg/text/?${encodeURIComponent(document.querySelector('meta[property="og:title"]').content)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}%0D%0A%0D%0A${encodeURIComponent(this.href+this.$route.path.split('/').reverse()[0])}`
                }
                // mobile in-app webview
                return `https://line.naver.jp/R/msg/text/?${encodeURIComponent(document.querySelector('meta[property="og:title"]').content)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[property="og:description"]').content)}%0D%0A%0D%0A${encodeURIComponent(this.href+this.$route.path.split('/').reverse()[0])}`
            },
            twittershareUrl() {
                return `https://twitter.com/intent/tweet?text=${encodeURIComponent(document.querySelector('meta[name="twitter:title"]').content)}%0D%0A%0D%0A${encodeURIComponent(document.querySelector('meta[name="twitter:description"]').content)}%0D%0A%0D%0A${encodeURIComponent(this.href+this.$route.path.split('/').reverse()[0])}`;
            },
            target() {
                if (!isMobile) return '_blank';
                return '_self';
            },
        },
        watch: {
            height: {
                handler: function(newHeight, oldHeight) {
                    if(newHeight > oldHeight) this.$store.state.hideNavBar = true;
                    else this.$store.state.hideNavBar = false;
                }
            },
        },
        methods:{
            handleHamburgerClick() {
                this.menuActiveFlag = !this.menuActiveFlag;
            },
            onScroll(e) {
                this.height = e.target.documentElement.scrollTop;


                let currentHeight = window.pageYOffset;
                let totalHeight = document.body.scrollHeight - window.innerHeight;
                
                if(Math.round((currentHeight/totalHeight)*10)*10>this.last_stage){
                    for(let i=this.last_stage+10;i<=Math.round((currentHeight/totalHeight)*10)*10;i=i+10){
                        this.sendGA({category: 'read', action: 'scroll', label: "read_"+this.$store.state.currentwisher+"_"+i.toString()+'%'});
                    }
                    this.last_stage = Math.round((currentHeight/totalHeight)*10)*10;
                }
            },
            clicktitle(){
                this.sendGA({category: 'udn 70 logo', action: 'click', label: '70_logo'});
            },
            clicksharefb(){
                this.sendGA(this.formatGA('HeaderShareFb'));
            },
            clickshareline(){
                this.sendGA(this.formatGA('HeaderShareLine'));
            },
            clicksharetwitter(){
                this.sendGA(this.formatGA('HeaderShareTwitter'));
            },
            hamburgerlink(linkpara){
                this.sendGA({category: 'menu bar', action: 'click', label: linkpara});
            },
            clicksidemenu(){
                if(!this.$store.state.menuflag) this.sendGA({category: 'wisher bar', action: 'click', label: 'click_wisher_bar'});
            }
        }
    }
</script>
  
<style lang="scss" scoped>
    .appheaderbg{
        position: fixed;
        z-index: 1500;
        top: 0;
        right: 0;
        width: 100%;
        .appheader_container{
            position: relative;
            display: flex;
            flex-direction: row;
            transition: all 0.3s ease-in-out;
            padding: 13px 15px 15px 13px;
            &.appheader_active{
                transform: translateY(-100%);
                overflow: auto;
            }
            @media (min-width: 768px) {
                padding: 13px 20px 15px 25px;
            }
            .logo{
                position: relative;
                z-index: 5005;
                width: 145px;
                height: 23.36px;
                margin-right: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                @media (min-width: 414px) {
                    width: 200px;
                    height: 32.22px;
                }
                a{
                    cursor: pointer;
                    .logomanage{
                        max-width: 100%;
                        max-height: 100%;
                        height: 100%;
                    }
                }
            }
            .contactpart{
                position: relative;
                height: 100%;
                flex-grow: 1;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                a{
                    width: 20px;
                    height: 20px;
                    margin-right: 5px;
                    @media (min-width: 300px) AND (max-width: 414px){
                        width: 25px;
                        height: 25px;
                        margin-right: 10px;
                    }
                    @media (min-width: 414px) {
                        width: 32px;
                        height: 32px;
                        margin-right: 10px;
                    }
                    img{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        text-decoration: none;
                        cursor: pointer;
                    }
                    @media (hover: hover) {
                        .s_fb:hover{
                            content: url('https://p3.udn.com.tw/wish/images/common/fb_golden.svg');
                        }
                        .s_line:hover{
                            content: url('https://p3.udn.com.tw/wish/images/common/line_golden.svg');
                        }
                        .s_twitter:hover{
                            content: url('https://p3.udn.com.tw/wish/images/common/twitter_golden.svg');
                        }
                    }
                }
                .hamburgercontain{
                    position: relative;
                }
            }
        }
    }
</style>